import React, { ReactNode } from 'react';
import ImageCard from '../ImageCard';
import IconPencil from '../Icons/IconPencil';
import ReactPlayer from 'react-player';
import Button from '../Button';
import './VideoCourseCard.less';

type VideoCourseCardProps = {
  addButton?: ReactNode;
  description?: string;
  buttonText?: string;
  videoUrl?: string;
  href?: string;
  image?: string;
  height?: string;
  videoSize?: Object;
  coverWidth?: string;
  coverHeight?: string;
  imgHeight?: string;
  handleAdd?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TVideoCourseCard: React.FC<VideoCourseCardProps> = ({
  href = '',
  image = '',
  handleAdd,
  buttonText,
  coverHeight,
  imgHeight,
}) => {
  return (
    <div className="t-course-videoPlayer-container">
      <ImageCard
        cover={
          image && (
            <div className="t-imageCover" style={{ height: coverHeight }}>
              <img
                height={imgHeight}
                width="100%"
                src={image}
                style={{ objectFit: 'cover' }}
              />
            </div>
          )
        }
      >
        {/* <div
          className="t-course-player-container"
          style={{ height: coverHeight }}
        >
          {href && !image && (
            <ReactPlayer
              muted={true}
              playing={false}
              controls
              width="100%"
              height="100%"
              url={href}
            />
          )}
        </div> */}

        <div className="t-button-wrapper">
          <Button
            size="large"
            fullWidth
            icon={
              <span>
                <IconPencil fill="currentcolor" size="md" />
              </span>
            }
            onClick={handleAdd}
          >
            {buttonText}
          </Button>
        </div>
      </ImageCard>
    </div>
  );
};

export default TVideoCourseCard;
